import { MODULE_CODES } from "@medicorepay/shared";
import { Route } from "react-router-dom";
import { ModuleProtectedRoute } from "../../components/auth/ModuleProtectedRoute";
import { PermissionProtectedRoute } from "../../components/auth/PermissionProtectedRoute";
import { CountersPage } from "../../pages/counters/CountersPage";
import { CreateCounterPage } from "../../pages/counters/CreateCounterPage";
import { CreateGoodsReceiptPage } from "../../pages/goods-receipts/CreateGoodsReceiptPage";
import { GoodsReceiptDetailPage } from "../../pages/goods-receipts/GoodsReceiptDetailPage";
import { GoodsReceiptsPage } from "../../pages/goods-receipts/GoodsReceiptsPage";
import { CreatePurchaseOrderPage } from "../../pages/purchase-orders/CreatePurchaseOrderPage";
import { EditPurchaseOrderPage } from "../../pages/purchase-orders/EditPurchaseOrderPage";
import { PurchaseOrderDetailPage } from "../../pages/purchase-orders/PurchaseOrderDetailPage";
import { PurchaseOrdersPage } from "../../pages/purchase-orders/PurchaseOrdersPage";
import { CreatePurchaseReturnPage } from "../../pages/purchase-returns/CreatePurchaseReturnPage";
import { PurchaseReturnDetailPage } from "../../pages/purchase-returns/PurchaseReturnDetailPage";
import { PurchaseReturnsPage } from "../../pages/purchase-returns/PurchaseReturnsPage";
import { SupplierBillDetailPage } from "../../pages/supplier-bills/SupplierBillDetailPage";
import { SupplierBillsPage } from "../../pages/supplier-bills/SupplierBillsPage";
import { StockAdjustmentsPage } from "../../pages/stock-adjustments/StockAdjustmentsPage";
import { CreateStorePage } from "../../pages/stores/CreateStorePage";
import { StoresPage } from "../../pages/stores/StoresPage";
import { CreateSupplierPage } from "../../pages/suppliers/CreateSupplierPage";
// Approval-mode screen retained but not routed in the simple pharmacy flow:
// import { SupplierApprovalsPage } from "../../pages/suppliers/SupplierApprovalsPage";
import { SupplierDetailPage } from "../../pages/suppliers/SupplierDetailPage";
import { SuppliersPage } from "../../pages/suppliers/SuppliersPage";
import { CreateUserPage } from "../../pages/users/CreateUserPage";
import { PermissionsPage } from "../../pages/users/PermissionsPage";
import { UsersPage } from "../../pages/users/UsersPage";

export const protectedOperationsRoutes = (
  <>
    <Route
      path="/suppliers"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SUPPLIER_MGMT}>
          <SuppliersPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/suppliers/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SUPPLIER_MGMT}>
          <CreateSupplierPage />
        </ModuleProtectedRoute>
      }
    />
    {/* Approval-mode route intentionally disabled:
        <Route path="/suppliers/approvals" element={...} /> */}
    <Route
      path="/suppliers/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SUPPLIER_MGMT}>
          <SupplierDetailPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/suppliers/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SUPPLIER_MGMT}>
          <CreateSupplierPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/stores"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.MULTI_STORE}>
          <StoresPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/stores/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.MULTI_STORE}>
          <CreateStorePage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/stores/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.MULTI_STORE}>
          <CreateStorePage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/users"
      element={
        <PermissionProtectedRoute requiredPermission="users:view">
          <UsersPage />
        </PermissionProtectedRoute>
      }
    />
    <Route
      path="/users/create"
      element={
        <PermissionProtectedRoute requiredPermission="users:create">
          <CreateUserPage />
        </PermissionProtectedRoute>
      }
    />
    <Route
      path="/users/:id/edit"
      element={
        <PermissionProtectedRoute requiredPermission="users:update">
          <CreateUserPage />
        </PermissionProtectedRoute>
      }
    />
    <Route
      path="/permissions"
      element={
        <PermissionProtectedRoute requiredRole="BUSINESS_OWNER">
          <PermissionsPage />
        </PermissionProtectedRoute>
      }
    />
    <Route
      path="/counters"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <CountersPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/counters/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <CreateCounterPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/counters/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <CreateCounterPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/stock-adjustments"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <StockAdjustmentsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/purchase-orders"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <PurchaseOrdersPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/purchase-orders/new"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <CreatePurchaseOrderPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/purchase-orders/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <CreatePurchaseOrderPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/purchase-orders/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <EditPurchaseOrderPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/purchase-orders/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <PurchaseOrderDetailPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/goods-receipts"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <GoodsReceiptsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/goods-receipts/new"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <CreateGoodsReceiptPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/goods-receipts/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <GoodsReceiptDetailPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/supplier-bills"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <SupplierBillsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/supplier-bills/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <SupplierBillDetailPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/purchase-returns"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <PurchaseReturnsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/purchase-returns/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <CreatePurchaseReturnPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/purchase-returns/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.PROCUREMENT}>
          <PurchaseReturnDetailPage />
        </ModuleProtectedRoute>
      }
    />
  </>
);
